import React from "react";
import { useCallback, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";
import {
  getDeliveryArrangement,
  postChangePickingDateDeliveryArrangement,
} from "../../../../redux/api/picking.api";
import {
  dateAndTimeForDatabase,
  dateForDatabase,
} from "../../../../utils/dateAndTime";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";
import ModalWrapper from "../../../../components/Modal/ModalWrapper";
import CustomButton from "../../../../components/CustomButton";
import Text from "../../../../styleguide/Text";
import { closeChangeDateDeliveryArrangementModal } from "../../../../redux/reducer/picking.reducer";
import DateTimePicker from "../../../../components/misc/DateTimePicker";

function ChangePickingDateForPackageModal() {
  const dispatch = useAppDispatch();
  const { routeParams } = useRoutesHelper();

  const {
    picking: {
      isChangeDateDeliveryArrangementModalOpen,
      selectedPackageChangingDate,
    },
  } = useAppSelector((state) => ({
    picking: state.picking,
  }));

  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleOnSubmit = useCallback(
    async ({ handleClose }: any) => {
      if (!selectedPackageChangingDate) {
        return;
      }
      setIsLoading(true);

      const resultAction = await dispatch(
        postChangePickingDateDeliveryArrangement({
          doc_trans: selectedPackageChangingDate.doc_trans,
          data_ridicare: dateAndTimeForDatabase(selectedDate),
        }),
      );

      if (
        checkEndpointStatus(
          resultAction,
          postChangePickingDateDeliveryArrangement,
        ) !== endpointStatus.pending
      ) {
        setIsLoading(false);
      }

      if (
        checkEndpointStatus(
          resultAction,
          postChangePickingDateDeliveryArrangement,
        ) === endpointStatus.fulfilled
      ) {
        const {
          page,
          rowsPerPage,
          status,
          facturi,
          ruta,
          deliveryPoint,
          commandNumber,
          createdAt,
        } = routeParams;

        const formatDate = dateForDatabase(createdAt);

        dispatch(
          getDeliveryArrangement({
            page: page,
            perPage: rowsPerPage,
            status: status ?? 0,
            facturi: facturi ?? "",
            ruta: ruta ?? "",
            deliveryPoint: deliveryPoint ?? "",
            commandNumber: commandNumber ?? "",
            createdAt: formatDate,
          }),
        );

        dispatch(closeChangeDateDeliveryArrangementModal());
        setSelectedDate(null);

        handleClose && handleClose();
      }
    },
    [selectedPackageChangingDate, dispatch, routeParams, selectedDate],
  );

  const isSubmitDisabled =
    !selectedPackageChangingDate?.doc_trans || !selectedDate;

  const onClose = useCallback(() => {
    dispatch(closeChangeDateDeliveryArrangementModal());
    setSelectedDate(null);
  }, [dispatch]);

  return (
    <>
      <ModalWrapper
        show={!!isChangeDateDeliveryArrangementModalOpen}
        title="Editare data ridicarii coletului"
        modalSize="sm"
        handleClose={onClose}>
        <div className="d-flex flex-column">
          <DateTimePicker
            label="Data si ora ridicarii"
            value={selectedDate}
            minDate={new Date()}
            handleChangeDate={(newDate) => setSelectedDate(newDate)}
          />
        </div>

        <CustomButton
          type="submit"
          variant="contained"
          fullWidth
          className="btn btn-lg btn-primary w-100 mt-5"
          disabled={isSubmitDisabled}
          loading={isLoading}
          onClick={handleOnSubmit}>
          <Text variant="body1" className="indicator-label" isBold>
            Salveaza
          </Text>
        </CustomButton>
      </ModalWrapper>
    </>
  );
}

export default ChangePickingDateForPackageModal;
